import { RefetchQueriesFunction } from '@apollo/client';
import React from 'react';
import { Card, CardBody } from 'reactstrap';
import OrderTransactionCashDetail, { TransactionCash } from './cash/OrderTransactionCashDetail';
import OrderTransactionCsobDetail, { TransactionCsob } from './csob/OrderTransactionCsobDetail';

interface OrderTransactionsListProps {
  transactionsCsob: TransactionCsob[];
  transactionsCash: TransactionCash[];
  refetchQueries: RefetchQueriesFunction;
}

export default function OrderTransactionsList({
  transactionsCsob,
  transactionsCash,
  refetchQueries
}: OrderTransactionsListProps) {
  return (
    <>
      {transactionsCsob.map(transactionCsob => {
        return (
          <React.Fragment key={transactionCsob.id}>
            <Card className="mb-4">
              <CardBody>
                <h5>Bezhotovostní transakce branou ČSOB č. {transactionCsob.id}</h5>
                <OrderTransactionCsobDetail transaction={transactionCsob} refetchQueries={refetchQueries} />
              </CardBody>
            </Card>
          </React.Fragment>
        );
      })}

      {transactionsCash.map(transactionCash => {
        return (
          <React.Fragment key={transactionCash.id}>
            <Card className="mb-4">
              <CardBody>
                <h5>Hotovostní transakce č. {transactionCash.id}</h5>
                <OrderTransactionCashDetail transaction={transactionCash} refetchQueries={refetchQueries} />
              </CardBody>
            </Card>
          </React.Fragment>
        );
      })}
    </>
  );
}
